var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50057 0.396484L12.5311 8.38398H0.470037L6.50057 0.396484Z",
    fill: "#00D95F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpboard);
export default __webpack_public_path__ + "static/media/upboard.6c6a9e5b8567ba15f3bc2e02e27480fb.svg";
export { ForwardRef as ReactComponent };